export { default } from "./DetailWhiteCard";